/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Icon, WingBlank } from "antd-mobile";
import { connect } from "react-redux";
import * as selectors from "../../selectors";
import * as searchAction from "../../actions/search";
import * as searchSelectors from "../../selectors/search";
import "./index.css";

const StyledContainer = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  background: ${props => (props.mode === "outline" ? "#EEEEEE" : "white")};
  color: grey;
  border: 1px solid lightgrey;
  padding: 0.6em;
  height: 0.98em;
`;

const StyledSearchContainer = styled.div`
  display: flex;
  direction: row;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
`;

const StyledIcon = styled(Icon)`
  cursor: pointer;
  color: grey;
`;

const StyledInput = styled.input`
  border: none;
  background: ${props => (props.mode === "outline" ? "#EEEEEE" : "white")};
  min-width: 80%;
`;

class SearchBar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchKeyword: "",
      timerId: ""
    };
  }

  componentWillUnmount() {
    this.clearTimer();
  }

  clearTimer() {
    clearTimeout(this.state.timerId);
  }

  onTextChange = txt => {
    const { changeListener } = this.props;

    this.clearTimer();
    let newTimerId = setTimeout(() => this.onSubmit(), 1000); //1sec count down
    this.setState({ searchKeyword: txt, timerId: newTimerId });
    changeListener && changeListener(txt);
  };

  onCancelClick = () => {
    const { changeListener } = this.props;

    this.setState({
      searchKeyword: ""
    });
    changeListener && changeListener("");
  };

  onSubmit = () => {
    const { searchKeyword } = this.state;
    const { startSearch, searchResult } = this.props;
    const searchResultFoodItems =
      searchResult && searchResult[searchKeyword]
        ? searchSelectors.getSearchDataFoodItems(searchResult[searchKeyword])
        : null;

    if (searchResultFoodItems == null) {
      startSearch && searchKeyword.length > 0 && startSearch(searchKeyword);
    }
  };

  render() {
    const { searchKeyword } = this.state;
    const { outline, loading } = this.props;

    return (
      <StyledContainer mode={outline ? "outline" : "inline"}>
        <StyledSearchContainer>
          <StyledIcon type={"search"} size={"xs"} />
          <WingBlank size="sm" />
          <StyledInput
            disabled={loading}
            mode={outline ? "outline" : "inline"}
            value={searchKeyword}
            autoFocus={true}
            autoComplete={"on"}
            onChange={v => this.onTextChange(v.target.value)}
          />
          <WingBlank size="sm" />
          <StyledIcon
            type={"cross-circle"}
            size={"xs"}
            onClick={() => this.onCancelClick()}
          />
        </StyledSearchContainer>
      </StyledContainer>
    );
  }
}

SearchBar.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
  focus: PropTypes.bool,
  outline: PropTypes.bool,
  loading: PropTypes.bool,
  searchResult: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  startSearch: PropTypes.func,
  changeListener: PropTypes.func
};

function mapStateToProps(state) {
  return {
    loading: selectors.getSearchLoading(state),
    searchResult: selectors.getSearchResult(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    startSearch: keyword => dispatch(searchAction.postNewSearchRequest(keyword))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchBar);



// WEBPACK FOOTER //
// ./src/components/SearchBar/index.js